export const naturalSortComparator = (v1: string, v2: string) => {
  return v1.localeCompare(v2, undefined, { numeric: true, sensitivity: 'base' })
}
